import React from "react";
import { LmsLoanPropertyTable } from "../ui/LmsSharedTables";

const LmsServicingProperties = () => <LmsLoanPropertyTable suffix="loanproperty/info-list" isServicing />;

export default LmsServicingProperties;